




































































import { defineComponent, PropType, useContext, ref, computed, watch } from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import { uniqueId } from 'lodash-es';
import AppClamp from '~/components/partials/App/AppClamp.vue';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLikeButton from '~/components/partials/App/AppLikeButton.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { BOTTLE_100, BOTTLE_200 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import priceFormatter from '~/utils/priceFormatter';
import { ECSchema } from '~/types/api';

export default defineComponent({
  components: {
    AppIcon,
    AppLink,
    AppImage,
    AppLikeButton,
    AppClamp,
  },
  props: {
    comment: {
      type: Object as PropType<ECSchema<'review.UserReview'>>,
      required: true,
    },
    isCommentLiked: {
      type: Boolean,
      default: false,
    },
    hasLikeButton: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const { i18n } = useContext();
    const likeOffset = ref(0);
    const likeCount = computed(() => props.comment.like + likeOffset.value);
    const handleLikeChange = (isCommentLiked: boolean) => {
      likeOffset.value += isCommentLiked ? 1 : -1;
      emit('change', isCommentLiked, props.comment.id);
    };
    const getProductDetails = (comment: ECSchema<'review.UserReview'>) => {
      return comment.producer?.name
        ? i18n
            .t('Common.comments.productDetail', {
              productName: comment.product_name,
              producerName: comment.producer.name,
            })
            .toString()
        : comment.product_name;
    };
    const formattedCreatedAt = computed(() => {
      return dayjs(props.comment.created_at).isValid()
        ? dayjs(props.comment.created_at).utcOffset(9).format('YYYY.MM.DD')
        : '';
    });

    // コメント情報が更新されると、offset をリセットする必要がある
    watch(
      () => props.comment,
      () => {
        likeOffset.value = 0;
      }
    );
    return {
      url,
      likeCount,
      handleLikeChange,
      uniqueId,
      priceFormatter,
      getProductDetails,
      formattedCreatedAt,
      BOTTLE_100,
      BOTTLE_200,
    };
  },
});
